import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router ,NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { environment } from 'src/app/environments/environment';
// import { ExcelExportReportInputs } from '../../models/excel-export-report.model';
import { ExcelExportReportInputs } from '../../models/excel-export-report.model';
import { ReportIssueInputs } from '../../models/reportIssue.model';
import { SharedPopupService } from '../../services/shared-popup.service';
import { LandingService } from 'src/app/core/services/landing.service';
import { shouldShowBellIcon } from '../../bell-icon-routes.util';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-header-home',
  templateUrl: './header-home.component.html',
  styleUrls: ['./header-home.component.css']
})
export class HeaderHomeComponent {
  toggleSetting: boolean = false;
  showClearAll: boolean = false;
  @Input() exportReportInput!: ExcelExportReportInputs;
  @Input() settingIconShown: boolean = true;
  @Input() additionalCheck: any;
  @Input() reportIssueInput!: ReportIssueInputs;
  @Input() isHelpGuide: boolean = false;
  showBellIcon! : boolean;
  @Input() hasDocuments: boolean = false;
  isDocumentRepository: boolean = true;
  exportDownloads : boolean = true;
  guideUrl = environment.UserGuideSnapshotUrl;
  @Input() moduleName!: string;
  triggerNew: boolean = false;
  showExportsDownloadsPopup: boolean = false;
  showReportIssuePopup: boolean = false;
  notifications: any[] = [];
  showNotification: boolean = false;

  // Notification state
  showNotificationPanel: boolean = false;
  hasNewNotifications: boolean = false;
  notificationCount: number = 0;

  @Output() OnSettingsSel = new EventEmitter<string>();
  @Output() documentRepoClick = new EventEmitter<void>();
  constructor(private router: Router, private _authenticateService: AuthenticationService, private sharedPopup: SharedPopupService, private landingService: LandingService) { }

  ngOnInit() {
    this.showBellIcon = this.landingService.getAlertAccess() && shouldShowBellIcon(this.router.url);
    // navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        const navEvent = event as NavigationEnd;
        this.showBellIcon = this.landingService.getAlertAccess() && shouldShowBellIcon(navEvent.urlAfterRedirects);
      });
      
    if (this.moduleName != undefined || this.moduleName != null) {
      this.settingOptions();
    }
    this.checkNotifications();
  }

  ngOnChanges() {
    if (this.moduleName != undefined || this.moduleName != null) {
      this.settingOptions();
    }
  }

  OnExportsDownloads() {
    this.showExportsDownloadsPopup = true;
  }

  onCloseExportDownloads() {
    this.showExportsDownloadsPopup = false;
  }

  OnReportIssue() {
    this.showReportIssuePopup = true;
  }

  onCloseReportIssue() {
    this.showReportIssuePopup = false;
  }

  settingOptions() {
    switch (this.moduleName) {
      case 'crosstab':
        this.isHelpGuide = false;
        this.isDocumentRepository = false;
        break;
      case 'snapshot':
        if (this.additionalCheck != undefined) {
          this.isHelpGuide = (this.additionalCheck?.find((x: any) => x.key == 'Help Guide'))?.length > 0;
        }
        this.isDocumentRepository = true;
        break;
      case 'customsnapshot':
        if (this.additionalCheck != undefined) {
        this.additionalCheck?.find((x: any) => x.key == 'Help Guide')?.value;
        }
        this.isDocumentRepository = true;
        break;
    }
  }

  redirectToLandingPage() {
    this.landingService.clearTextToTopicStudySelection();
    this.router.navigate(['/landing']);
  }
  onUserManagementClick() {
    this.router.navigate(['/user-management']);
  }
  onUserGuideClick() {
    const guideUrl = this.guideUrl;
    window.open(guideUrl, '_blank');
  }
  LogOut() {
    this._authenticateService.logout();
  }
  OnSettingClick() {
    this.toggleSetting = !this.toggleSetting;
  }
  closeSummary() {
    this.toggleSetting = false;
  }

  settingOptionSel(item : any){
    this.toggleSetting = false;
    this.OnSettingsSel.emit(item);
  }

  
  HandleDocumentClick() {
    this.documentRepoClick.emit();
    this.toggleSetting = false;
  }
  
  checkNotifications() {
    if (!this.showBellIcon) {
      return;
    }

    const study = this.landingService.getSelectedStudy() ?? '';
    const client = this.landingService.getSelectedClient() ?? '';
    const userEmail = localStorage.getItem('useremail') ?? '';
    
    if (!study || !client || !userEmail) return;
    
    this.sharedPopup.getTriggeredAlertList(userEmail, client, study).subscribe((value: any) => {
      const parsedData = JSON.parse(value.Data);
      this.notificationCount = parsedData.TriggeredAlerts.totalCount || 0;
      if (this.notificationCount > 0) {
        this.hasNewNotifications = true;
      }
    });
  }

  onNotificationClick(notification: any, event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // don't toggle when clicking interactive elements (checkbox, link, button, label, select, textarea')
    if (target.closest('input, a, button, label, select, textarea')) {
      return;
    }
    notification.checked = !notification.checked;
  }
  
  /**
   * Handle notification count changes from the panel
   */
  onNotificationCountChange(count: number): void {
    this.notificationCount = count;
    this.hasNewNotifications = count > 0;
  }

  /**
   * Toggle notification panel open/close
   */
  toggleNotificationPanel(): void {
    this.showNotificationPanel = !this.showNotificationPanel;
  }
}
